import getConfig from 'next/config';

import { ISearchConfig } from 'homepage/types/SectionSearchConfig';
import {
  PRODUCT_CAROUSEL_ROWS_SECTION_RESULTS_PER_PAGE,
  PRODUCT_GRID_SECTION_RESULTS_PER_PAGE,
} from 'homepage/enums/contentConstants';
import { CONSTRUCTOR_SERVICE_URL } from 'search/enums/constants';

export const buildRequestUrl = (
  searchConfig,
  isProductGridSection = false,
  isProductCarouselSection = false,
  rowCount = 1,
) => {
  const {
    publicRuntimeConfig: { CONSTRUCTOR_API_KEY },
  }: { publicRuntimeConfig: { CONSTRUCTOR_API_KEY: string } } = getConfig();

  const {
    type: searchType,
    filterKey,
    filterValue,
    options,
    collectionId,
    query,
  }: ISearchConfig = searchConfig;

  // special case for this module because we need to fetch a specific amount of items per row included in the section
  if (isProductCarouselSection) {
    const queryParams = options.replace('num_results_per_page=25', '');
    const appendQueryParams = queryParams ? `&${queryParams}` : '';
    const numOfItems = PRODUCT_CAROUSEL_ROWS_SECTION_RESULTS_PER_PAGE * rowCount;

    if (searchType === 'search') {
      const url = `${CONSTRUCTOR_SERVICE_URL}/${searchType}/${query}?num_results_per_page=${numOfItems}${appendQueryParams}&key=${CONSTRUCTOR_API_KEY}`;
      return url;
    }

    const url =
      collectionId && collectionId?.length > 0
        ? `${CONSTRUCTOR_SERVICE_URL}/browse/collection_id/${collectionId}?num_results_per_page=${numOfItems}${appendQueryParams}&key=${CONSTRUCTOR_API_KEY}`
        : `${CONSTRUCTOR_SERVICE_URL}/${searchType}/${filterKey?.toLowerCase()}/${filterValue}?num_results_per_page=${numOfItems}${appendQueryParams}&key=${CONSTRUCTOR_API_KEY}`;
    return url;
  }

  // special case for this grid because we need to fetch enough items to fill the width of the page
  if (isProductGridSection) {
    const queryParams = options.replace('num_results_per_page=25', '');
    const appendQueryParams = queryParams ? `&${queryParams}` : '';

    if (searchType === 'search') {
      const url = `${CONSTRUCTOR_SERVICE_URL}/${searchType}/${query}?num_results_per_page=${PRODUCT_GRID_SECTION_RESULTS_PER_PAGE}${appendQueryParams}&key=${CONSTRUCTOR_API_KEY}`;
      return url;
    }

    const url =
      collectionId && collectionId?.length > 0
        ? `${CONSTRUCTOR_SERVICE_URL}/browse/collection_id/${collectionId}?num_results_per_page=${PRODUCT_GRID_SECTION_RESULTS_PER_PAGE}${appendQueryParams}&key=${CONSTRUCTOR_API_KEY}`
        : `${CONSTRUCTOR_SERVICE_URL}/${searchType}/${filterKey?.toLowerCase()}/${filterValue}?num_results_per_page=${PRODUCT_GRID_SECTION_RESULTS_PER_PAGE}${appendQueryParams}&key=${CONSTRUCTOR_API_KEY}`;
    return url;
  }

  if (searchType === 'search') {
    const url = `${CONSTRUCTOR_SERVICE_URL}/${searchType}/${query}?${options}&key=${CONSTRUCTOR_API_KEY}`;
    return url;
  }

  const url =
    collectionId && collectionId?.length > 0
      ? `${CONSTRUCTOR_SERVICE_URL}/browse/collection_id/${collectionId}?${options}&key=${CONSTRUCTOR_API_KEY}`
      : `${CONSTRUCTOR_SERVICE_URL}/${searchType}/${filterKey?.toLowerCase()}/${filterValue}?${options}&key=${CONSTRUCTOR_API_KEY}`;
  return url;
};
